import { render, staticRenderFns } from "./ExhibitorResultCard.vue?vue&type=template&id=e1013e98&"
import script from "./ExhibitorResultCard.vue?vue&type=script&lang=ts&"
export * from "./ExhibitorResultCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports